import { createReducer } from "utilities";
import * as TYPES from "./constants";
import { LANG_NAME, LANGUAGES } from "CONSTANTS";

// consider only languages declared in LANGUAGES;
// take lang from localStorage / navigator / default (en);
const navigatorLang = navigator && navigator.language.split("-")[0];
const initialState = {
  language: LANGUAGES.find(el => el === (localStorage[LANG_NAME] || navigatorLang)) || "en",
  modal: {
    open: null,
    extra: undefined,
  },
  highlights: localStorage.highlights
    ? JSON.parse(localStorage.highlights)
    : {
        order: null,
      },
};

const reducer = createReducer(initialState, {
  [TYPES.CHANGE_LANGUAGE](state, { language }) {
    return {
      ...state,
      language,
    };
  },
  [TYPES.MODAL_OPEN](state, action) {
    const { id, extra } = action;
    return {
      ...state,
      modal: {
        open: id,
        extra,
      },
    };
  },
  [TYPES.MODAL_CLOSE](state) {
    return {
      ...state,
      modal: {
        open: null,
        extra: undefined,
      },
    };
  },
  [TYPES.CHANGE_HIGHLIGHT](state, { name, id }) {
    return {
      ...state,
      highlights: {
        ...state.highlights,
        [name]: id,
      },
    };
  },
});

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/ui/reducer.js